<template>
  <div>
    <div class="mt-2 text-caption text-center grey--text">
      Preview: How the rating question will appear to users
    </div>
    <div class="rating-question">
      <div v-if="title" class="text-subtitle-1 font-weight-medium mb-2">{{ title }}</div>
      <div v-if="description" class="text-body-2 mb-3">{{ description }}</div>
      <v-rating
        v-model="previewRating"
        color="warning"
        hover
        length="5"
        size="32"
        readonly
      ></v-rating>
    </div>
  </div>
</template>

<script>
export default {
  name: "RatingQuestion",

  props: {
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      previewRating: 3,
    };
  },
};
</script>

<style scoped>
.rating-question {
  padding: 16px;
  border-radius: 4px;
  background-color: #f5f5f5;
  text-align: center;
  max-width: 300px;
  margin: 0 auto;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>
